import { Channel, EmbedCSS } from "@swivl-mono/types";
import { clearAllBodyScrollLocks, disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import React, { Component } from "react";
import { isIOS, isIPad13, isMobile, isTablet } from "react-device-detect";

import { SwivlChat } from "../SwivlChat";
import WindowResizeListener from "./components/WindowResizeListener";
import CTAView from "./components/cta/CTAView";
import Dot from "./components/dot/Dot";
import Header from "./components/header/Header";
import { addClass, removeClass } from "./helpers/SSClassHelper";
import LayoutForProps from "./layout/LayoutForProps";
import "./styles/IOSFocusFix.scss";
import "./styles/styles.css";

interface Props {
  config: any;
  embedId: string;
  server: string;
  webSocketServer: string;
  notificationsServer: string;
  messagingServer: string;
  swivl: any;
  embedSettings: any;
}
interface State {
  isLoaded: boolean;
  isOpen: boolean;
  isFormFocused: boolean;
  isTriggeringGoto: boolean;
  isHovered: boolean;
  showCTA: boolean;
  ctaHasAppeared: boolean;
  ctaStartOnQuest?: string;
  cta?: any;
  windowSize?: any;
  customSize?: any;
  customHeaderText?: string;
  customDotText?: string;
  auth?: any;
}
export class SwivlEmbed extends React.Component<Props, State> {
  config;

  openTimer;
  embedCSS;
  isTablet;
  chatRef;
  wrapperRef;
  secretInputRef;
  unmounting;
  constructor(props: Props) {
    super(props);

    this.isTablet = isIPad13 || isTablet ? true : false;
    if (isIOS && !isMobile) {
      this.isTablet = true;
    }

    let state: State = {
      isLoaded: false,
      isOpen: false,
      isFormFocused: false,
      isTriggeringGoto: false,
      isHovered: false,
      showCTA: false,

      ctaHasAppeared: false
    };

    this.config = props.config;
    if (this.config) {
      if (this.config.startOpen) {
        state.isOpen = true;
      }

      if (this.config.showCTA) {
        state.showCTA = true;
        const willDelayCTA = this.config.ctaDelay && this.config.ctaDelay > 0 ? true : false;

        state.ctaHasAppeared = willDelayCTA ? false : true;
        if (willDelayCTA) {
          setTimeout(() => {
            this.triggerCTA();
          }, this.config.ctaDelay * 1000);
        } else {
          setTimeout(() => {
            this.ctaDidTrigger();
          }, 100);
        }
        state.cta = {
          title: this.config.ctaTitle,
          imageURL: this.config.ctaImageURL,
          body: this.config.ctaBody
        };
        state.ctaStartOnQuest = willDelayCTA ? undefined : this.config.ctaStartOnQuest;
      }
    }
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams && urlParams.get("swivlOpen") && urlParams.get("swivlOpen") === "true") {
      state.isOpen = true;
    }
    if (urlParams && urlParams.get("swivlStartOnQuest")) {
      this.config.startOnQuest = urlParams.get("swivlStartOnQuest");
    }
    if (urlParams && urlParams.get("swivlReferredBy")) {
      if (!this.config.preloadVariable) {
        this.config.preloadVariables = {};
      }
      this.config.preloadVariables["User:ReferredBy"] = urlParams.get("swivlReferredBy");
      if (urlParams && urlParams.get("swivlReferredByName")) {
        this.config.preloadVariables["User:ReferredByName"] = urlParams.get("swivlReferredByName");
      }
    }

    this.onConnectionOpened = this.onConnectionOpened.bind(this);

    this.updateDimensions = this.updateDimensions.bind(this);
    this.toggleOpen = this.toggleOpen.bind(this);

    this.embedCSS = EmbedCSS(this.config, "#swivl_" + this.config.orgId);

    this.orientationChanged = this.orientationChanged.bind(this);
    this.resize = this.resize.bind(this);

    this.onFormFocus = this.onFormFocus.bind(this);
    this.onFormBlur = this.onFormBlur.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);

    this.shouldOpen = this.shouldOpen.bind(this);

    this.triggerGoToQuest = this.triggerGoToQuest.bind(this);
    this.triggerSetVariables = this.triggerSetVariables.bind(this);

    this.triggerOpen = this.triggerOpen.bind(this);
    this.triggerClose = this.triggerClose.bind(this);
    this.triggerToggle = this.triggerToggle.bind(this);
    this.openOrClose = this.openOrClose.bind(this);
    this.triggerSetHeaderText = this.triggerSetHeaderText.bind(this);
    this.triggerSetDotText = this.triggerSetDotText.bind(this);
    this.triggererSendMessage = this.triggererSendMessage.bind(this);
    this.triggerSetSize = this.triggerSetSize.bind(this);
    this.triggerLoadPastMessages = this.triggerLoadPastMessages.bind(this);
    this.triggerClearMessages = this.triggerClearMessages.bind(this);

    this.triggerCTA = this.triggerCTA.bind(this);
    this.hideCTA = this.hideCTA.bind(this);
    this.ctaDidTrigger = this.ctaDidTrigger.bind(this);

    this.renderCustomSize = this.renderCustomSize.bind(this);
    this.renderTest = this.renderTest.bind(this);

    this.onMessageSent = this.onMessageSent.bind(this);
    this.resetOpenTimer = this.resetOpenTimer.bind(this);
    if (props.swivl) {
      props.swivl.goToQuest = this.triggerGoToQuest;
      props.swivl.setVariables = this.triggerSetVariables;
      props.swivl.open = this.triggerOpen;
      props.swivl.close = this.triggerClose;
      props.swivl.toggle = this.triggerToggle;
      props.swivl.setHeaderText = this.triggerSetHeaderText;
      props.swivl.setDotText = this.triggerSetDotText;
      props.swivl.setSize = this.triggerSetSize;
      props.swivl.sendMessage = this.triggererSendMessage;
      props.swivl.loadPastMessages = this.triggerLoadPastMessages;
      props.swivl.clearMessages = this.triggerClearMessages;
    }
    if (props.embedSettings) {
      if (props.embedSettings.size) {
        state.customSize = props.embedSettings.size;
      }
      if (props.embedSettings.auth) {
        state.auth = props.embedSettings.auth;
      }
    }

    this.chatRef = React.createRef();
    this.wrapperRef = React.createRef();
    this.secretInputRef = React.createRef();

    this.testTouchDown = this.testTouchDown.bind(this);

    this.state = state;
  }

  componentDidMount() {
    if ((window as any).Swivl?.onReady) {
      (window as any).Swivl.onReady();
    }
    // setInterval(this.resize, 3000)
    window.addEventListener("orientationchange", this.orientationChanged);
    // document.body.addEventListener("touchmove", freezeVp, {passive:false});
  }

  componentDidUpdate(prevProps, prevState) {
    // if (!this.state.isLoaded && this.state.windowSize) {
    //
    //   // this.setState({isLoaded:true})
    //
    // }
    if (!prevState.isOpen && this.state.isOpen) {
      this.resize();
      this.setState({ showCTA: false });
      this.resetOpenTimer();
    }
    if (this.state.isFormFocused != prevState.isFormFocused && isMobile && !this.isTablet) {
      this.stopBodyScrolling(this.state.isFormFocused);
    }
  }

  componentWillUnmount() {
    this.stopBodyScrolling(false);
    window.removeEventListener("orientationchange", this.orientationChanged);
    clearAllBodyScrollLocks();
    this.unmounting = true;
  }

  onConnectionOpened() {
    var self = this;
    if (self.props.swivl && self.props.swivl.onReady) {
      self.props.swivl.onReady();
    }
    self.setState({ isLoaded: true });
  }

  stopBodyScrolling(bool) {
    if (this.unmounting) {
      return;
    }
    const me = this.wrapperRef.current;
    // const scrollListItems = document.getElementsByClassName("scc-messageList")
    // if (scrollListItems && scrollListItems.length > 0) {
    //   const scrollList = scrollListItems[0]
    //
    if (bool === true) {
      disableBodyScroll(me, {
        allowTouchMove: (el) => {
          while (el && el !== document.body) {
            if (el.getAttribute("body-scroll-lock-ignore") !== null) {
              // return true;
              if (el.scrollTop == 0) {
                // NOTE: If we let it ever langish at zero we will have issues.
                el.scrollTop = -1;
              } else {
                return true;
              }
            }

            el = el.parentNode;
          }
        }
      });

      // me.addEventListener("touchmove", freezeVp, {passive:false});
    } else {
      enableBodyScroll(me);

      // me.removeEventListener("touchmove", freezeVp, {passive:false});
    }
    // }
  }
  orientationChanged(e) {
    setTimeout(this.resize, 100);
    setTimeout(this.resize, 2000);
  }
  resize() {
    var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    var windowHeight = window.innerHeight || document.body.clientHeight || document.documentElement.clientHeight || document.body.clientHeight;
    this.setState({ windowSize: { width: windowWidth, height: windowHeight } });
  }
  // NOTE: So we have a few options here. IF we want everything to move up, remove the resizes.
  onFormFocus() {
    this.setState({ isFormFocused: true });
    // setTimeout(this.resize, 100)
    // setTimeout(this.resize, 500)
  }
  onFormBlur() {
    this.setState({ isFormFocused: false });
    setTimeout(this.resize, 100);
    setTimeout(this.resize, 500);
  }
  onMouseEnter() {
    this.setState({ isHovered: true });
  }
  onMouseLeave() {
    this.setState({ isHovered: false });
  }

  shouldOpen(reason) {
    if (this.props.swivl && this.props.swivl.shouldOpenCallback && !this.props.swivl.shouldOpenCallback(reason)) {
      return false;
    }
    return true;
  }

  triggerGoToQuest(questId) {
    if (this.chatRef && this.chatRef.current && this.chatRef.current.triggerGoToQuest) {
      this.chatRef.current.triggerGoToQuest(questId);

      if (this.shouldOpen("trigger")) {
        this.setState({ isOpen: true, isTriggeringGoto: true });
      } else {
        this.setState({ isTriggeringGoto: true });
      }

      var self = this;
      setTimeout(function () {
        self.setState({ isTriggeringGoto: false });
      }, 200);
    }
  }
  triggerSetVariables(variableObject) {
    if (this.chatRef && this.chatRef.current && this.chatRef.current.triggerSetVariables) {
      this.chatRef.current.triggerSetVariables(variableObject);
    }
  }
  triggerOpen() {
    if (this.shouldOpen("user")) {
      this.setState({ isOpen: true });
    }
  }
  triggerClose() {
    this.setState({ isOpen: false });
  }
  triggerToggle() {
    this.toggleOpen();
  }
  triggererSendMessage(text, silent) {
    if (this.chatRef && this.chatRef.current && this.chatRef.current.userEnteredText) {
      this.chatRef.current.userEnteredText(text, silent);
    }
  }
  triggerLoadPastMessages() {
    if (this.chatRef && this.chatRef.current && this.chatRef.current.loadPastMessages) {
      this.chatRef.current.loadPastMessages();
    }
  }
  triggerClearMessages() {
    if (this.chatRef && this.chatRef.current && this.chatRef.current.clearMessages) {
      this.chatRef.current.clearMessages();
    }
  }
  openOrClose(open) {
    if (open && this.shouldOpen("chat")) {
      this.triggerOpen();
    } else {
      this.triggerClose();
    }
  }
  updateDimensions(windowSize) {
    var w = window,
      d = document,
      e = d.documentElement,
      g = d.getElementsByTagName("body")[0],
      x = w.innerWidth || e.clientWidth || g.clientWidth,
      y = w.innerHeight || e.clientHeight || g.clientHeight;

    this.setState({ windowSize: { width: windowSize.windowWidth, height: windowSize.windowHeight } });
  }
  toggleOpen() {
    if (!this.state.isOpen) {
      if (this.shouldOpen("user")) {
        this.setState({ isOpen: !this.state.isOpen, isHovered: false });
      }
    } else {
      this.setState({ isOpen: !this.state.isOpen, isHovered: false });
    }
  }
  triggerSetHeaderText(headerText) {
    this.setState({ customHeaderText: headerText });
  }
  triggerSetDotText(dotText) {
    this.setState({ customDotText: dotText });
  }
  triggerSetSize(customSize) {
    this.setState({ customSize: customSize });
  }

  renderCustomSize(customSize) {
    const embedCSS = this.embedCSS;

    return (
      <div className="sce-customSizeWrapper swivl-body" style={{ width: customSize.width + "px", height: customSize.height + "px" }}>
        <style dangerouslySetInnerHTML={{ __html: embedCSS }} />
        <div className="sce-chatWrapper swivl-body" style={{ width: customSize.width + "px", height: customSize.height + "px" }}>
          <SwivlChat
            config={this.config}
            // orgId={this.config.orgId}
            server={this.props.server}
            webSocketServer={this.props.webSocketServer}
            messagingServer={this.props.messagingServer}
            ref={this.chatRef}
            isOpen={this.state.isOpen}
            isTriggeringGoto={this.state.isTriggeringGoto}
            parentControlsStart={true}
            onFormFocus={this.onFormFocus}
            onFormBlur={this.onFormBlur}
            commandCallback={this.props.swivl.commandCallback}
            auth={this.state.auth}
            onConnectionOpened={this.onConnectionOpened}
            isMobile={isMobile}
            thirdPartyId={this.props.embedSettings.thirdPartyId}
            preloadVariables={this.props.embedSettings.preloadVariables}
            channel={Channel.WEB}
          />
        </div>
      </div>
    );
  }

  testTouchDown(e) {
    var x = this.secretInputRef.current;
    x?.focus();
    const wrapperEl = this.wrapperRef.current;
    setTimeout(function () {
      var y = wrapperEl?.querySelector(".scc-formInput") as HTMLElement;
      y?.focus();
    }, 400);
  }

  triggerCTA() {
    if (this.state.showCTA) {
      this.setState({ ctaHasAppeared: true, ctaStartOnQuest: this.config.ctaStartOnQuest });
      this.ctaDidTrigger();
    }
  }
  hideCTA(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ showCTA: false, ctaStartOnQuest: undefined });
  }
  renderCTA(drawCTA) {
    if (drawCTA) {
      // if (this.state.showCTA && this.state.ctaHasAppeared && this.state.cta) {
      return (
        <CTAView
          show={this.state.showCTA}
          hideCTA={this.hideCTA}
          cta={this.state.cta}
          open={this.triggerOpen}
          isMobile={isMobile && !isTablet}
          position={this.config.position}
          collapsedStyle={this.config.collapsedStyle}
          windowSize={this.state.windowSize}
          config={this.config}
        />
      );
    }
  }
  ctaDidTrigger() {
    if (this.config.ctaAnalytics) {
      const payload = this.config.ctaAnalytics;
      if (payload.platform && payload.platform == "GTM") {
        if (!payload.event) {
          return;
        }
        if ((window as any).dataLayer) {
          (window as any).dataLayer.push({ event: payload.event });
        } else {
        }
      } else if (payload.platform && payload.platform == "GA") {
        try {
          const category = payload.category || "Swivl-Category";
          const action = payload.action || "Swivl-Action";
          const label = payload.label && payload.label.length ? payload.label : "Swivl-Label";
          (window as any).ga("send", "event", category, action, label);
        } catch (e) {}
      } else if (payload.platform && payload.platform == "GTAG") {
        const action = payload.action || "Swivl-Action";
        const category = payload.category || "Swivl-Category";
        const label = payload.label && payload.label.length ? payload.label : null;

        if ((window as any).gtag) {
          var gtagPayload = { event_category: category };
          if (label) {
            (gtagPayload as any).event_label = label;
          }
          (window as any).gtag("event", action, gtagPayload);
        } else {
        }
      } else {
      }
    }
  }

  onMessageSent(_message) {
    this.resetOpenTimer();
  }

  resetOpenTimer() {
    if (this.state.isOpen) {
      if (this.openTimer) {
        clearTimeout(this.openTimer);
      }
      this.openTimer = setTimeout(() => {
        if (this.state.isOpen) {
          this.setState({ isOpen: false });
        }
      }, 7200000);
      // two hours in miliseconds = 7200000
    }
  }

  render() {
    // return <SwivlLayout />;

    // return this.renderTest()

    if (this.state.customSize) {
      return this.renderCustomSize(this.state.customSize);
    }

    if (!this.state.windowSize) {
      return <WindowResizeListener onResize={this.updateDimensions} />;
    }

    var { layout, wrapperStyle, clickWrapperStyle, swivlEmbedStyle, chatWrapperStyle, arrowTransform } = LayoutForProps(
      this.state.windowSize,
      isMobile,
      this.isTablet,
      isIOS,
      this.state.isOpen,
      this.state.isFormFocused,
      this.state.isHovered,
      this.config.position,
      this.config.collapsedStyle,
      this.config
    );

    // var peak = (this.state.isHovered) ? -10 : -30;

    var embedCSS = this.embedCSS;

    // var className;
    var wrapperClassName = "sce-SwivlEmbedWrapper";
    wrapperClassName += this.state.isOpen ? " sce-isOpen" : " sce-isClosed";
    // wrapperClassName += (isMobile) ? " swivl-isMobile" : "";
    // swivl-body
    const openScrim = isMobile && this.state.isFormFocused ? <div className="sce-backgroundScrim swivl-body"></div> : null;
    //
    var className = "sce-SwivlEmbed swivl-mainBackground";

    // if (this.state.isLoaded) { className += " sce-isLoaded" }
    // var WIDTH = (this.state.windowSize) ? Math.min(layout.maxWidth, this.state.windowSize.width) : 0;
    // var headerLeftOffset = 0;
    if (isMobile && !(this.isTablet || isIPad13) && document && document.body) {
      if (this.state.isOpen) {
        addClass(document.body, "swivl-mobileIsOpen");
      } else {
        removeClass(document.body, "swivl-mobileIsOpen");
      }
    }

    const notificationsServer = this.props.notificationsServer ? this.props.notificationsServer : import.meta.env.VITE_NOTIFICATIONS_SERVER_URL;

    const bodyOnClick = !this.state.isOpen ? this.triggerOpen : null;

    const drawCTA = this.state.showCTA && this.state.ctaHasAppeared && this.state.cta ? true : false;

    const dot =
      !this.config.collapsedStyle || this.config.collapsedStyle == "bar" ? null : (
        <Dot
          config={this.config}
          customHeaderText={this.state.customHeaderText}
          customDotText={this.state.customDotText}
          layout={layout}
          toggleOpen={this.toggleOpen}
          windowSize={this.state.windowSize}
          isMobile={isMobile}
          isTablet={this.isTablet}
          hideTitle={drawCTA}
        />
      );

    // NOTE: These are to handle some of iOSs focus quirks.
    var hiddenInput, touchCapture;
    if (isIOS) {
      hiddenInput = (
        <div className="sce-hiddenInput">
          <input ref={this.secretInputRef} type="text" id="superSecretInput" />
        </div>
      );
      if (!this.state.isFormFocused) {
        touchCapture = <div className="sce-touchCapture" onClick={this.testTouchDown} />;
      }
    }

    return (
      <div ref={this.wrapperRef} id={"swivlEmbed_" + this.props.embedId} className={wrapperClassName} style={wrapperStyle}>
        {openScrim}
        {dot}
        {this.renderCTA(drawCTA)}

        <div
          className="sce-clickWrapper"
          onClick={bodyOnClick as any}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
          style={clickWrapperStyle}
        >
          {hiddenInput}

          <div className={className} style={swivlEmbedStyle}>
            <style dangerouslySetInnerHTML={{ __html: embedCSS }} />
            <WindowResizeListener onResize={this.updateDimensions} />

            <Header
              config={this.config}
              width={layout.width}
              layout={layout}
              toggleOpen={this.toggleOpen}
              arrowTransform={arrowTransform}
              customHeaderText={this.state.customHeaderText}
            />
            <div className="sce-chatWrapper swivl-body" style={chatWrapperStyle}>
              <SwivlChat
                config={this.config}
                server={this.props.server}
                webSocketServer={this.props.webSocketServer}
                notificationsServer={notificationsServer}
                messagingServer={this.props.messagingServer}
                ref={this.chatRef}
                isOpen={this.state.isOpen}
                isTriggeringGoto={this.state.isTriggeringGoto}
                parentControlsStart={true}
                onFormFocus={this.onFormFocus}
                onFormBlur={this.onFormBlur}
                commandCallback={this.props.swivl.commandCallback}
                auth={this.state.auth}
                onConnectionOpened={this.onConnectionOpened}
                generateCSS={false}
                isMobile={isMobile}
                thirdPartyId={this.props.embedSettings.thirdPartyId}
                preloadVariables={this.props.embedSettings.preloadVariables}
                startOnQuestId={this.state.ctaStartOnQuest && this.state.ctaStartOnQuest.length ? this.state.ctaStartOnQuest : undefined}
                onMessageSent={this.onMessageSent}
                channel={Channel.WEB}
              />
              {touchCapture}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderTest() {
    return (
      <div className="sce-wrapper">
        <div className="sce-body">
          <div className="sce-header">I'm the header</div>
          <div className="sce-chat">
            I'm the body
            <input style={{ fontSize: "16px" }} />
          </div>
        </div>
      </div>
    );
  }
}
